import { useChatStore } from '@store/chat';
import { PrimaryButton, SecondaryButton } from '@ui/buttons';
import Checkbox from '@ui/checkbox';
import { DialogModal } from '@ui/dialogModal';
import type { Dataset } from 'types/schema';
import Styled from './DatasetSelectorConfirmDialog.styled';

interface Props {
  open: boolean;
  dataset: Dataset | null;
  onChangeDataset: (dataset: Dataset) => void;
  onClose: () => void;
}

function DatasetSelectorConfirmDialog(props: Props) {
  const messageCount = useChatStore((state) => state.chat.messages.length);

  if (props.dataset === null) {
    return;
  }

  const title = `Changing data set to ${props.dataset.title}`;

  const content = (
    <Styled.Content>
      When you switch data sets your <b>saved audience access</b> will change.
      {messageCount > 0 && ' Your previous messages will stay in this chat.'}
    </Styled.Content>
  );

  const handleCheckboxClick = (state: 'checked' | 'unchecked') => {
    window.localStorage.setItem(
      'octopus.dataset.skip_confirmation',
      (state === 'checked').toString()
    );
  };

  const footer = (
    <Styled.Footer>
      <Styled.CheckboxWrapper>
        <Checkbox
          label="Don't show again"
          data-testid="dataset-skip-checkbox"
          onClick={handleCheckboxClick}
        />
      </Styled.CheckboxWrapper>
      <Styled.Actions>
        <SecondaryButton
          className="button"
          testId="dataset-cancel-button"
          onClick={props.onClose}>
          Cancel
        </SecondaryButton>
        <PrimaryButton
          className="button"
          testId="dataset-change-button"
          onClick={() => props.onChangeDataset(props.dataset)}
          disabled={!props.dataset}>
          Change data set
        </PrimaryButton>
      </Styled.Actions>
    </Styled.Footer>
  );

  return (
    <DialogModal
      open={props.open}
      title={title}
      main={content}
      testId="dataset-change-dialog"
      footerRight={footer}
    />
  );
}

export default DatasetSelectorConfirmDialog;
